import React, { useMemo } from 'react';
import * as echarts from 'echarts';
import { transChannel } from '@/pages/opinion/utils';
import EChartCommon, {
  getAxisPointer,
} from '@/pages/opinion/components/EChartCommon';
import {
  formatChartParamsDate,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { formatTimeXAxisText } from '@/pages/opinion/utils/chart';

export default function MiniChart({
  isSentiment = false,
  statistics = { x: [], y: [] },
  text,
  dateType,
  dealwithYFunc,
  dealwithValueFunc,
  rightTitle,
}: any) {
  const options = useMemo(() => {
    let legendData: {
      name: string;
      itemStyle: {
        color: string;
      };
    }[] = [];
    let xAxisData: string[] = statistics?.x || [];
    let seriesData: any[] = [
      {
        symbol: 'circle',
        symbolSize: 0,
        data: statistics?.y || [],
        type: 'line',
        lineStyle: {
          width: 2,
          color: '#376AE7',
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(55, 106, 231, 0.3)',
            },
            {
              offset: 1,
              color: 'rgba(209,230,250,0.00)',
            },
          ]),
        },
      },
    ];

    const option = {
      animation: false,
      tooltip: {
        formatter: (param: any) => {
          let { name } = param?.[0] || {};
          return formatChartParamsDate({
            params: param,
            rightTitle: text,
            title: listTimeTitleFunc(name, dateType),
            listTitleFunc: () => rightTitle,
            valueFormat: dealwithValueFunc,
          });
        },
      },
      legend: {
        data: legendData,
        formatter: (params: any) => {
          return transChannel(params);
        },
      },
      grid: {
        top: '20px',
        right: '10px',
        bottom: '0px',
      },
      axisPointer: getAxisPointer((data) =>
        formatTimeXAxisText(data.value, dateType),
      ),
      xAxis: {
        data: xAxisData,
        boundaryGap: 'line',
        axisLabel: {
          formatter: (value: string) => formatTimeXAxisText(value, dateType),
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (value: number) => {
            const data = dealwithYFunc(Math.abs(value));
            return value >= 0 ? data : `-${data}`;
          },
        },
        ...(isSentiment ? { max: 5, min: 0, splitNumber: 5 } : {}),
      },
      series: seriesData,
    };

    return option;
  }, [statistics]);

  return (
    <EChartCommon
      optionsProps={{ excludeOptions: ['axisPointer'] }}
      options={options}
      height={170}
    ></EChartCommon>
  );
}
